import type { CuratedStory, Image, Video } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    INTEGRITY_FAIL_MEDIA,
    firstItemOnly,
} from "~utils/moduleIntegrity";

interface SingleStoryAdaptiveHfsIntegrityProps {
    items?: CuratedStory[];
    image?: Image;
    embedUrl?: string;
    liveStream?: string;
    video?: Video;
}

export default function integrityCheck({
    items = [],
    image,
    embedUrl,
    liveStream,
    video,
}: SingleStoryAdaptiveHfsIntegrityProps): IntegrityStatus {
    const messages = checkItemArrayIntegrity(
        firstItemOnly<CuratedStory>(items)
    );

    // This variation needs some form of multimedia to be valid.
    if (
        !(
            embedUrl ||
            liveStream ||
            video ||
            image?.baseUrl ||
            (items?.length && items[0].image?.baseUrl)
        )
    ) {
        messages.push(INTEGRITY_FAIL_MEDIA);
    }

    return messages;
}
